import { render, staticRenderFns } from "./EmailExpired.vue?vue&type=template&id=64cfe6de&scoped=true"
import script from "./EmailExpired.vue?vue&type=script&lang=js"
export * from "./EmailExpired.vue?vue&type=script&lang=js"
import style0 from "./EmailExpired.vue?vue&type=style&index=0&id=64cfe6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfe6de",
  null
  
)

export default component.exports